// extracted by mini-css-extract-plugin
export const panel = "text-panel-module--panel--21lMU";